import type { MonospacePolicyEntitlementResource } from '#layers/access/public';
import { RStoreSchema } from '#imports';

export const SystemEntitlementResource = RStoreSchema.withItemType<MonospacePolicyEntitlementResource>().defineCollection({
	name: 'SystemEntitlementResource',
	scopeId: 'monospace-default',
	getKey: (item) => item.name,
	meta: {
		endpoint: 'entitlements',
		parse: { many: (response) => response.resources },
	},
});
